const ContentToolkitServiceMembership = {
  ContentDeveloper: "CONTENT_DEVELOPER",
  Learner: "LEARNER",
  Instructor: "INSTRUCTOR"
};
const ContentToolkitServiceModeClaim = {
  Take: "TAKE",
  Review: "REVIEW",
  ClassReview: "CLASS_REVIEW",
  Design: "DESIGN"
};
const CourseAssessmentSubtype = {
  Exam: "EXAM",
  PracticeExam: "PRACTICE_EXAM",
  PracticeTest: "PRACTICE_TEST",
  Quiz: "QUIZ",
  Test: "TEST"
};
const CourseImplementationType = {
  None: "NONE",
  Cr: "CR",
  Ic: "IC",
  Hon: "HON"
};
const CourseStatus = {
  Active: "ACTIVE",
  Archived: "ARCHIVED",
  Draft: "DRAFT"
};
const CourseToolType = {
  Calculator: "CALCULATOR",
  ReferenceSheet: "REFERENCE_SHEET",
  Other: "OTHER"
};
const ReviewMode = {
  AnswersOnly: "SHOW_ANSWERS_ONLY",
  CorrectAnswers: "SHOW_CORRECT_ANSWERS"
};
export {
  ContentToolkitServiceMembership,
  ContentToolkitServiceModeClaim,
  CourseAssessmentSubtype,
  CourseImplementationType,
  CourseStatus,
  CourseToolType,
  ReviewMode
};
